import { render, staticRenderFns } from "./LoadingCustomerSpinner.vue?vue&type=template&id=98772a7e&scoped=true"
import script from "./LoadingCustomerSpinner.vue?vue&type=script&lang=js"
export * from "./LoadingCustomerSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98772a7e",
  null
  
)

export default component.exports